import { entityTypeEnum } from "../enums/entity.enum";

export const isEntity = (subRole: string, role: string) => subRole === "ENTITY_ADMIN" && role === "OTHER";

export const getFirstTwoChr = (firstName: string, lastName: string) =>
  `${firstName?.slice(0, 1)}${lastName?.slice(0, 1)}`;

export const displayRole = (user: any, subRole: string | null, role: string | null) => {
  const IS_ENTITY = subRole && role ? isEntity(subRole, role) : false;
  return IS_ENTITY
    ? //   @ts-ignore
      entityTypeEnum[user?.entity?.type]
    : user.role;
};

export const formatImgUrl = (IMGName?: string | null, isCountry?: boolean) => {
  const BASE_IMG = process.env.REACT_APP_IMGIX_URL || "";
  const IMG_URL = BASE_IMG + IMGName;
  return IMG_URL;
};
